var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109 109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#2d338d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "successCheck1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.49,36a4.11,4.11,0,0,0-1.36-.89,4.14,4.14,0,0,0-3.19,0,4.11,4.11,0,0,0-1.36.89l-31,30.39-13-12.79a4.21,4.21,0,0,0-1.39-.88,4.35,4.35,0,0,0-3.25.05,4.12,4.12,0,0,0-1.36.93,4.11,4.11,0,0,0-1.2,3,4.13,4.13,0,0,0,.35,1.59,4.32,4.32,0,0,0,.95,1.33l16,15.65a4.24,4.24,0,0,0,4.55.89,4.12,4.12,0,0,0,1.35-.89L82.49,42a4.22,4.22,0,0,0,1-1.36A4.06,4.06,0,0,0,83.82,39a4.08,4.08,0,0,0-1.33-3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.5,0A54.5,54.5,0,1,0,109,54.5,54.5,54.5,0,0,0,54.5,0ZM82,40.21,47.48,74.73a2.37,2.37,0,0,1-3.4,0l-16.95-17a2.4,2.4,0,0,1,3.39-3.39L45.78,69.64,78.6,36.82A2.4,2.4,0,0,1,82,40.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/successCheck.c93c887c043919bc6630354c80b0bea0.svg";
export { ForwardRef as ReactComponent };